import { ERROR_CODES } from '@/consts';

export default class FundNotFound extends Error {
  static code = ERROR_CODES.CASH_LOG_BRANCH_NOT_FOUND;

  constructor(message) {
    super(message || 'Branch not found.');
    this.code = ERROR_CODES.CASH_LOG_BRANCH_NOT_FOUND;
  }
}
